// extracted by mini-css-extract-plugin
export default {"bold":"price-range__bold___ZdiFw","thumb":"price-range__thumb___qtcMm"};